import React from 'react';
import { useParams } from 'react-router-dom';
import { useSupportTicketDetails } from '../hooks/use-support-ticket-details.js';
import SupportTicketDetailsView from './support-ticket-details-view.jsx';

function SupportTicketDetailsContainer() {
  const { uid } = useParams();
  const state = useSupportTicketDetails(uid);

  return <SupportTicketDetailsView {...state} />;
}

export default SupportTicketDetailsContainer;
